var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.437 10.249a5.667 5.667 0 1 1 .943-.943l5.425 5.425a.667.667 0 1 1-.943.943zm.825-4.451a4.333 4.333 0 1 1-8.667 0 4.333 4.333 0 0 1 8.667 0",
    clipRule: "evenodd"
  })));
};
export default SvgSearchIcon;